// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__oC_rt","noInteraction":"EventWrapper_noInteraction__fEGxZ","pointerPassthrough":"EventWrapper_pointerPassthrough__Kr-AL"};